import { colorAccent, colorText } from '@/utils/palette';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';

function Breadcrumb({ breadcrumbs }) {
  const { pathname } = useLocation();
  const pathnames = pathname.split('/').filter((x) => x);

  const isClickDisabled = (name, fullPath) => {
    const isTicketOrProjectRoute =
      pathname.includes('/all_projects_tickets/') || pathname.includes('/tickets_dashboard/');
    if (!isTicketOrProjectRoute) return false;
    return name === 'ticket' || name === 'project';
  };
  const formatString = (str, fullPath) => {
    // const noFormatRoutes = ['/projects', '/allprojects', '/tickets', '/alltickets'];
    const noFormatRoutes = ['/projects', '/tickets'];
    if (noFormatRoutes.some((route) => fullPath.toLowerCase().startsWith(route))) {
      return str;
    }

    if (str === 'Companymanagement') {
      return 'Company Management';
    }

    const allRegex = /^all(\w+)/i;
    if (allRegex.test(str)) {
      const remainder = str.replace(allRegex, '$1');
      const formattedRemainder = remainder
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_([a-z])/g, (match, char) => ` ${char.toUpperCase()}`)
        .replace(/%20/g, ' ');

      return `All ${formattedRemainder.charAt(0).toUpperCase() + formattedRemainder.slice(1)}`;
    }

    if (!str.includes('All')) {
      return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_([a-z])/g, (match, char) => ` ${char.toUpperCase()}`)
        .replace(/%20/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
    }

    const regex = /^(All)(\w)/;
    return str.replace(regex, (_, p1, p2) => `${p1} ${p2.toUpperCase()}`);
  };

  return (
    <StyledBreadcrumbs
      aria-label='breadcrumb'
      separator='>'
    >
      {pathnames?.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const breadcrumbName = breadcrumbs[routeTo] || name;
        const formattedName = breadcrumbName.charAt(0).toUpperCase() + breadcrumbName.slice(1);
        const formattedString = formatString(formattedName, routeTo);
        const isDisabled = isClickDisabled(name.toLowerCase(), routeTo);

        if (isLast || isDisabled) {
          return (
            <Typography
              color={colorAccent}
              key={routeTo}
              sx={{
                cursor: isDisabled ? 'default' : 'pointer',
                opacity: isDisabled ? 0.7 : 1,
              }}
            >
              {formattedString}
            </Typography>
          );
        }
        return isLast ? (
          <Typography
            color={colorAccent}
            key={routeTo}
          >
            {formattedString}
          </Typography>
        ) : (
          <>
            {formattedName === 'Documents' || formattedName === 'Alerts_services' ? (
              <Link
                color='inherit'
                component={RouterLink}
                to={routeTo}
                key={routeTo}
              >
                <Typography>{formattedString}</Typography>
              </Link>
            ) : (
              <Link
                color='inherit'
                component={RouterLink}
                to={routeTo}
                key={routeTo}
              >
                <Typography>{formattedString}</Typography>
              </Link>
            )}
          </>
        );
      })}
    </StyledBreadcrumbs>
  );
}

export default Breadcrumb;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  width: 100%;

  .MuiBreadcrumbs-separator {
    color: ${colorText};
    margin: 0 8px;
    font-size: 16px;
    font-weight: 600;
  }

  .MuiTypography-root {
    font-weight: 400;
  }

  .MuiLink-root {
    text-decoration: none;
    color: ${colorText};

    &:hover {
      text-decoration: underline;
    }
  }
`;
